import React, { useContext } from 'react';
import { __enum_SystemPages, __SystemPagesPaths } from '../common/Dictionaries';
import { useHistory } from "react-router-dom";
import homeBg from '../images/new_icohome-bg.png';
import bookicon from '../images/ico_new_book.png';
import coicon from '../images/ico_new_co.png';
import epicon from '../images/ico_new_pay.png';
import kpiicon from '../images/ico_new_kpi.png';
import pycicon from '../images/ico_new_pyc.png';
import pcicon from '../images/ico_new_pc.png';

import bookicon_off from '../images/ico_new_book_off.png';
import coicon_off from '../images/ico_new_co_off.png';
import epicon_off from '../images/ico_new_pay_off.png';
import kpiicon_off from '../images/ico_new_kpi_off.png';
import pycicon_off from '../images/ico_new_pyc_off.png';
import pcicon_off from '../images/ico_new_pc_off.png';

import box_diagram from '../images/BoxDiagram.png';

import landingProductHeader from '../images/header_home.png';
import tripontisLogo from '../images/tripontis-logo9-BR.gif';
import './style.css'
import { ActionButton, Icon } from '@fluentui/react';
import { Col, Row } from 'react-bootstrap';
import MainAppContext from '../MainAppContext';
import { __onGoToProductHome } from '../common/SystemRedirections';
import moment from 'moment';
import { useSelector } from 'react-redux';
import AuthVerify from '../components/Templates/Site/AuthVerify';

const HomeLandingV2 = (props) => {
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);

    const history = useHistory();
    const products = currentAuth.token.products

    const nRows = 3;
    const nColsMin = 2;
    const imgs = [
        { src: kpiicon,  src_off: kpiicon_off,  shape: "hexagon", onClickDestinity: __enum_SystemPages.BoardLanding, enabled: (products === 4 || products === 3) },
        { src: coicon,   src_off: coicon_off,   shape: "hexagon", onClickDestinity: null, enabled: false },
        { src: pycicon,  src_off: pycicon_off,  shape: "hexagon", onClickDestinity: null, enabled: false },
        { src: homeBg,   src_off: homeBg,       shape: "circle" , onClickDestinity: null, enabled: false },
        { src: epicon,   src_off: epicon_off,   shape: "hexagon", onClickDestinity: null, enabled: false },
        { src: pcicon,   src_off: pcicon_off,   shape: "hexagon", onClickDestinity: null, enabled: false },
        { src: bookicon, src_off: bookicon_off, shape: "hexagon", onClickDestinity: __enum_SystemPages.HomeBook, enabled: (products === 4 || products === 1) }
    ];
  
    const nColsMax = nColsMin + 1;
    const nColsSum = nColsMax + nColsMin;
    const n = Math.ceil(0.5 * nRows) * nColsMin + Math.floor(0.5 * nRows) * nColsMax;
    const ni = imgs.length;
  
    const getGridCells = () => {
        let cells = [];
        for (let i = 0; i < n; i++) {
            cells.push(
                <div
                    key={i}
                    style={{cursor: imgs[i % ni].enabled ? "pointer" : "default"}}
                    className={imgs[i % ni].shape === "hexagon" ? (imgs[i % ni].enabled ? "hex-cell" : "hex-cell disabled") : "hex-cell-circle"}
                    onClick={
                        imgs[i % ni].enabled ?
                        (imgs[i % ni].onClickDestinity !== null ? () => __onGoToProductHome(__SystemPagesPaths[imgs[i % ni].onClickDestinity].text, history, contextSite): undefined)
                        :
                        undefined
                    }
                >
                    <img src={imgs[i % ni].enabled ? imgs[i % ni].src : imgs[i % ni].src_off} alt={`img-${i}`} style={{cursor: imgs[i % ni].enabled ? "pointer" : "default"}} />
                </div>
            );
        }
        return cells;
    };

    const stylesHeaderCint = {
        backgroundImage: `url(${landingProductHeader})`,
        backgroundPosition: 'center, right bottom',
        //backgroundSize: 'contain',
        //height: "385px",
        width: "auto",
        color: "black",
        backgroundRepeat: "repeat-x"  
    };

    if (products === 1) {
        __onGoToProductHome(__SystemPagesPaths[__enum_SystemPages.HomeBook].text, history, contextSite)
    }
    else if(products === 3) {
        __onGoToProductHome(__SystemPagesPaths[__enum_SystemPages.BoardLanding].text, history, contextSite)
    }

    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            <div id="tbl" className="w-100">
                <Row className="my-5 d-flex align-items-center" style={stylesHeaderCint}>
                    <div className='landing-header-text'>
                        <h1 className='mb-0'><b>&nbsp;</b></h1>
                        <h5>&nbsp;</h5>
                    </div>
                </Row>
            </div>
            <div style={{marginTop: "-50px", width: "100%", position: "absolute", zIndex: "9"}}>
                <Row className='gradHomeLanding'>
                    <Col className='text-center col-auto mx-auto d-flex align-items-center'>
                        <div id="tbl" className="w-100">
                            <Row className="my-5 d-flex align-items-center" style={stylesHeaderCint}>
                                <div className='landing-header-text'>
                                    <h1 className='mb-0' style={{color: "white"}}><b>Tripontis SG3 Plus</b></h1>
                                    <h5><b>Tecnología para la Gestión de Servicios de Terceros</b></h5>
                                </div>
                            </Row>
                        </div>
                    </Col>
                    <Col className='text-center col-auto mx-auto d-flex align-items-center'>
                        <div className="image-grid-container" style={{ '--n-rows': nRows, '--n-cols': 2 * nColsMax }}>
                            {getGridCells()}
                        </div>
                    </Col>
                    <Col className='text-center col-auto mx-auto d-flex align-items-center'>
                        <div id="tbl" className="w-100">
                            <Row className="my-5 d-flex align-items-center" style={stylesHeaderCint}>
                                <div className='landing-header-text d-flex'>
                                    <div className='mb-0'>
                                        <img src={box_diagram} />
                                    </div>
                                    <h5><b>Selecciona un producto para continuar.</b></h5>
                                </div>
                            </Row>
                        </div>
                    </Col>
                </Row>

            





                <Row>
                    <Col className='text-center my-auto'>
                        <div style={{
                                backgroundImage: `url(${tripontisLogo})`,
                                backgroundPosition: 'center, right bottom',
                                backgroundSize: 'contain',
                                height: "100px",
                                width: "auto",
                                backgroundRepeat: "no-repeat, no-repeat"  
                            }}>
                        </div>
                    </Col>
                </Row>
                <Row className='footer fixed-bottom'>
                    <Col className='text-center'>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <ActionButton onClick={null} iconProps={{ iconName: 'Mail', styles: { root: { fontSize: 28 } }, textContainer:{ paddingTop: "10px"} }} style={{ fontSize: "20px", fontWeight: "400" }} allowDisabledFocus>
                                            info@Tripontis.com
                                        </ActionButton>
                                    </Col>
                                    <Col>
                                        <ActionButton onClick={null} iconProps={{ iconName: 'ThisPC', styles: { root: { fontSize: 28 } }, textContainer:{ paddingTop: "10px"} }} style={{ fontSize: "20px", fontWeight: "400" }} allowDisabledFocus>
                                            www.tripontis.com
                                        </ActionButton>
                                    </Col>
                                    <Col>
                                        <ActionButton onClick={null} iconProps={{ iconName: 'ProductVariant', styles: { root: { fontSize: 28 } }, textContainer:{ paddingTop: "10px"} }} style={{ fontSize: "20px", fontWeight: "400" }} allowDisabledFocus>
                                            Descripción de Productos
                                        </ActionButton>
                                    </Col>
                                    <Col>
                                        <ActionButton onClick={null} iconProps={{ iconName: 'People', styles: { root: { fontSize: 28 } }, textContainer:{ paddingTop: "10px"} }} style={{ fontSize: "20px", fontWeight: "400" }} allowDisabledFocus>
                                            Nuestros Servicios
                                        </ActionButton>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className='col-auto'>
                                <div className='d-flex float-end pt-2' style={{fontSize: "20px"}}>
                                    <Icon className='pe-2' styles={{root:{fontSize: "22px"}}} iconName='Calendar'/>
                                    <div className='pe-2'>{moment(Date.now()).format('YYYY')}</div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </>
    )
}
export default HomeLandingV2